export const TABLE_SELECT_ALL_VALUE = '__TABLE_SELECT_ALL__';
export const TableSortOrder = {
    ascending: 'ascending',
    descending: 'descending',
};
export var TableActionVariant;
(function (TableActionVariant) {
    TableActionVariant["DESELECT"] = "DESELECT";
    TableActionVariant["DESELECT_ALL"] = "DESELECT_ALL";
    TableActionVariant["SELECT"] = "SELECT";
    TableActionVariant["SELECT_ALL"] = "SELECT_ALL";
    TableActionVariant["SET_SORT"] = "SET_SORT";
    TableActionVariant["TOGGLE_SORT_ORDER"] = "TOGGLE_SORT_ORDER";
})(TableActionVariant || (TableActionVariant = {}));
export const defaultTableState = {
    deselect: () => {
        // Default implementation
    },
    deselectAll: () => {
        // Default implementation
    },
    isMultiSort: false,
    isSelectAll: false,
    select: () => {
        // Default implementation
    },
    selectAll: () => {
        // Default implementation
    },
    setSort: () => {
        // Default implementation
    },
    selected: [],
    sortConfig: [],
    toggleSortOrder: () => {
        // Default implementation
    },
};
